module.exports = __webpack_public_path__ + "static/media/bgsu-logo.decb995b.jpg";